/**
 * # Newsroom - Interior
 */

/**
 * ## Imports
 */
import './Newsroom.scss';

import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Link from '../../common/components/Link/Link';
//import NavigationBarSticky from '../../common/components/NavigationBarSticky/NavigationBarSticky';
import NavigationBar from '../../common/components/NavigationBar/NavigationBar';
import NewsBox from '../../common/components/NewsBox/NewsBox';
import PageFooter from '../../common/components/PageFooter/PageFooter';
import PageWrapperDark from '../../common/components/PageWrapperDark/PageWrapperDark';

/**
 * ## Component
 * @returns React
 */
function Newsroom() {
    const { t } = useTranslation('websiteV2');

    return (
        <>
            <Helmet>
                <title lang="en">Tempest - Newsroom</title>
                <meta name="description" content="Tempest launches to take private search mainstream " />
            </Helmet>
            <div className="homepage homepage--interior homepage--dark" lang="en">
                {/* <NavigationBarSticky /> */}
                <PageWrapperDark>
                    <NavigationBar onDarkBackground={true} />
                    <section className="content-teaser__section content-teaser__section--skewed">
                        <div className="home-centerwrapper news-wrapper">
                            <h1 className="homepage-headline">
                                {t('homepage-shared-footer-company-list-newsroom', 'Newsroom')}
                            </h1>

                            <Link
                                to={'/newsroom/q-and-a-with-michael-levit-tempests-past-present-and-future'}
                                className="newsbox-link"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-06-22"
                                    dateTimeLabel="Jun 22, 2023"
                                    labelHeadline="Q&A with Michael Levit: Tempest's Past, Present and Future"
                                    labelCopyText="At Tempest, we're on a mission to increase privacy and data security online. With products like Tempest Search and Tempest Browser, we prioritise the needs of individuals..."
                                    imageSrc="./images/homepage_rebrand/assets/newsroom/q-and-a-michael.png"
                                    isMainNews
                                />
                            </Link>

                            <a
                                href={
                                    'https://www.standard.co.uk/business/how-giant-pieces-of-spyware-are-shaping-our-views-and-our-world-search-engines-google-climate-change-b1083903.html'
                                }
                                target="_blank"
                                className="newsbox-link"
                                rel="noreferrer"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-05-27"
                                    dateTimeLabel="May 27, 2023"
                                    labelHeadline="How Giant Pieces of Spyware Are Shaping Our Views and Our World"
                                    labelCopyText="I magine a stack of newspapers on the tube where each one is different depending on the reader. The stories were chosen just for you. Would this be a dreamy utopia where you are getting exactly what you want?"
                                    imageSrc="./images/homepage_rebrand/assets/newsroom/giant_pieces_of_spyware.jpg"
                                />
                            </a>

                            <Link
                                to={'/newsroom/search-giants-continue-to-crush-privacy-pioneers'}
                                className="newsbox-link"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-05-25"
                                    dateTimeLabel="May 25, 2023"
                                    labelHeadline="Search Giants Continue to Crush Privacy Pioneers"
                                    labelCopyText="We are saddened to hear that Neeva is shutting down. We appreciate and share Neeva's commitment to the vision of providing users with a privacy-..."
                                    imageSrc="./images/homepage_rebrand/assets/newsroom/neeva-comment.png"
                                />
                            </Link>

                            <a
                                href={'https://www.safetydetectives.com/blog/michael-levit-tempest/'}
                                target="_blank"
                                className="newsbox-link"
                                rel="noreferrer"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-05-07"
                                    dateTimeLabel="May 7, 2023"
                                    labelHeadline="Interview with Michael Levit - CEO and Co-Founder of Tempest"
                                    labelCopyText="SafetyDetectives spoke with Michael Levit, CEO and co-founder of Tempest, about data privacy in search, how AI is impacting the search industry, why..."
                                    imageSrc="./images/homepage_rebrand/assets/newsroom/co-founder.png"
                                    imageAlign={'right'}
                                />
                            </a>

                            <a
                                href={
                                    'https://www.maddyness.com/uk/2023/04/27/some-things-are-better-left-private-meet-tempest/'
                                }
                                target="_blank"
                                className="newsbox-link"
                                rel="noreferrer"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-04-27"
                                    dateTimeLabel="Apr 27, 2023"
                                    labelHeadline="Some things are better left private, meet Tempest"
                                    labelCopyText="As part of our quick fire questions series – or QFQs – we spoke to Michael Levit, CEO and cofounder of Tempest about increasing online privacy..."
                                    imageSrc="./images/homepage_rebrand/assets/newsroom/some-things-are-better-left-private-meet-tempest-img.png"
                                    imageAlign={'right'}
                                />
                            </a>

                            <Link
                                to={'/newsroom/tempest-launches-to-take-private-search-mainstream'}
                                className="newsbox-link"
                            >
                                <NewsBox
                                    dateTimeAttr="2023-03-29"
                                    dateTimeLabel="Mar 29, 2023"
                                    labelHeadline="Tempest launches to take private search mainstream"
                                    labelCopyText="From creators who advocate for social change, to creators who teach us something new..."
                                    imageSrc="./images/homepage_rebrand/assets/newsroomarticle2023032401_v2.png"
                                />
                            </Link>
                        </div>
                    </section>
                </PageWrapperDark>
                <PageFooter withAnchorNavi={false} />
            </div>
        </>
    );
}

export default Newsroom;
